const LANG_DEF_FN = function(hljs) {
  const KEYWORDS = [
    '若 抑 否 当 循 遍历 于 断 续 返 尝试 捕捉 异步 等待 并行 引 予 匹配 终',
    '且 或 非 是 接着 设 常 型 函 造 公 私 护 承 口 变量 常量 函数 外 覆 弱',
  ].join(' ')

  const TYPES = '整 小数 字 逻 判 空 数组 字典 字节 结果 任务 字符串 整数 逻辑'
  const LITERALS = '真 假 空 此'
  const BUILT_INS = '示 化 解 求 听 连 执 道 输 成功 失败 打印 文件 网络 字符串 数学 时 系统 时间'

  return {
    name: 'XuanTie',
    aliases: ['xuantie', '玄铁'],
    keywords: {
      $pattern: /[一-鿿_a-zA-Z0-9㐀-䶿]+/,
      keyword: KEYWORDS,
      type: TYPES,
      literal: LITERALS,
      built_in: BUILT_INS
    },
    contains: [
      hljs.COMMENT('//', '$'),
      { className: 'string', variants: [
        { begin: /"/, end: /"/, contains: [hljs.BACKSLASH_ESCAPE] },
        { begin: /“/, end: /”/, contains: [hljs.BACKSLASH_ESCAPE] }
      ]},
      { className: 'number', variants: [{ begin: /\b\d+\.\d+\b/ }, { begin: /\b\d+\b/ }] },
      {
        className: 'title.function',
        begin: /[一-鿿_a-zA-Z][一-鿿\w]*(?=\s*\()/,
      },
      { className: 'variable', begin: /(?<=\.)[一-鿿_a-zA-Z][一-鿿\w]*/ },
      { className: 'operator', begin: /(==|!=|<=|>=|<|>|->|\+|-|\*|\/|%|&|\|)/ }
    ]
  }
}

// Register on our local hljs (blog detail page)
import hljs from 'highlight.js'
hljs.registerLanguage('xt', LANG_DEF_FN)

// Intercept mavon-editor's CDN-loaded window.hljs
let _stored = null
Object.defineProperty(window, 'hljs', {
  get() { return _stored },
  set(val) {
    _stored = val
    if (val && val.registerLanguage) {
      val.registerLanguage('xt', LANG_DEF_FN)
    }
  },
  configurable: true,
  enumerable: true
})
